package com.solevo.dist.components

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import com.solevo.dist.sections.DashboardHeader
import com.solevo.dist.util.Constants.COLLAPSED_PANEL_HEIGHT
import com.solevo.dist.util.Constants.SIDE_PANEL_WIDTH
import com.solevo.dist.viewmodels.NotificationsViewModel
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxSize
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.flexGrow
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.theme.breakpoint.rememberBreakpoint
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.vh

/**
 * Created by Ilija Vucetic on 29.9.25..
 * Copyright (c) 2025 Aktiia. All rights reserved.
 */
@Composable
fun DashboardPageLayout(
    header: (@Composable () -> Unit)? = null,
    content: @Composable () -> Unit
) {
    val bp = rememberBreakpoint()
    var overflowOpened by remember { mutableStateOf(false) }
    var notificationsOpen by remember { mutableStateOf(false) }
    val notificationsViewModel = remember { NotificationsViewModel() }
    val notificationsUi by notificationsViewModel.state.collectAsState()

    LaunchedEffect(notificationsOpen) {
        if (notificationsOpen) notificationsViewModel.start()
        else notificationsViewModel.stop()
    }

    Box(Modifier.fillMaxSize(), contentAlignment = Alignment.Center) {
        Column(Modifier.fillMaxSize()) {
            SidePanel(onMenuClick = { overflowOpened = true })

            if (overflowOpened) {
                OverflowSidePanel(
                    onMenuClose = { overflowOpened = false },
                    content = {
                        NavigationItems()
                        Box(Modifier.flexGrow(1))
                        com.solevo.dist.components.SettingsNavigationItem()
                    }
                )
            }

            Column(
                modifier = Modifier
                    .fillMaxWidth()
                    .height(100.vh)
                    .then(
                        if (bp > Breakpoint.MD)
                            Modifier.padding(left = SIDE_PANEL_WIDTH.px)
                        else
                            Modifier.padding(top = COLLAPSED_PANEL_HEIGHT.px)
                    )
            ) {
                Column(
                    modifier = Modifier
                        .fillMaxWidth()
                        .styleModifier {
                            property("position", "sticky")
                            property("top", "0")
                            property("z-index", "3")
                            property("background", "white")
                        }
                ) {
                    DashboardHeader(onBellClick = { notificationsOpen = true })
                    header?.invoke()
                }

                Box(
                    modifier = Modifier
                        .fillMaxWidth()
                        .flexGrow(1f)
                        .styleModifier {
                            property("overflow-y", "auto")
                            property("position", "relative")
                        }
                ) {
                    content()
                }
            }
        }

        // NotificationsPanel rendered outside sticky header stacking context
        NotificationsPanel(
            isOpen = notificationsOpen,
            onClose = { notificationsOpen = false }
        ) {
            NotificationsContent(
                ui = notificationsUi,
                viewModel = notificationsViewModel,
                onNotificationClick = { notificationId ->
                    println("Notification clicked: $notificationId")
                }
            )
        }
    }
}
